import RepositoryFactory from "../../marcom/Apicall/RepositoryFactory";
const landingPage = RepositoryFactory.landingPage;

export default {
  getAllLandingPage({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await landingPage.getAllLandingPage(payload);

        // console.log(data);

        commit("SET_LANDINGPAGE", data.data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addLandingPage({}, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await landingPage.addLandingPage(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  editLandingPage({}, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await landingPage.editLandingPage(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteLandingPage({}, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await landingPage.deleteLandingPage(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateFullURL({}, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await landingPage.updateFullURL(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getSingle({}, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await landingPage.getSingle(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateOpens({}, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await landingPage.updateOpens(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateClientClick({}, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await landingPage.updateClientClick(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
